import React from "react";
import "./Third.css";
import { Container } from "react-bootstrap";
import webTech from "../../../../Asset/web-technology.svg";
import webSupp from "../../../../Asset/web-support.svg";
import webDeploy from "../../../../Asset/web-deployment.svg";
import webTest from "../../../../Asset/web-testing.svg";
import webCod from "../../../../Asset/web-coding.svg";

const Third = () => {
  const cardData = [
    {
      id: 1,
      img: webTech,
      title: "Technology selection",
      description:
        "Our solutions are characterized by their tech-heavy centricity and are designed to surpass the usual methods of solving problems. The greater picture for technology-driven digital transformation that was once impossible is considered when building a sophisticated frontend and a user-friendly backend.",
    },
    {
      id: 2,
      img: webCod,
      title: "Robust Coding",
      description:
        "We translate your digital vision from elegant designs to custom-coded websites through a radical development phase driven by digital mindfulness.",
    },
    {
      id: 3,
      img: webTest,
      title: "End-to-end Testing",
      description:
        "Our knowledge of technology engineering allows us to conduct a meticulous QA testing process that is focused on speed, security, user experience, and functionality and eliminates any defects before a product is released.",
    },
    {
      id: 4,
      img: webDeploy,
      title: "Deployment",
      description:
        "As a leading web and mobile app development company, we offer cutting-edge solutions that stand the test of time across multiple environments, including production and staging.",
    },
    {
      id: 5,
      img: webSupp,
      title: "Support",
      description:
        "The expertise of our technology experts ensures seamless app performance, maintains the latest technology trends, and keeps up with the latest technological advancements.",
    },
  ];
  return (
    <>
      <section className="feature-list-block">
        <Container>
          <div className="top-text-third-webDevelopment">
            <h2>
              HOW WE <span>DO ?</span>
            </h2>
          </div>
          <div className="row card-items">
            {cardData?.map(({ id, img, title, description }) => (
              <div key={id} className="col-md-4 flex-column mb-50">
                <div className="card-item no-hover">
                  <div className="card-img">
                    <img alt={title} src={img} />
                  </div>
                  <div className="card-content">
                    <h3>{title}</h3>
                    <p className="sort-info">{description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
};

export default Third;
